import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, breakpoints, layout }: ITheme) => ({
    container: {
      padding: [0, '48px'],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, '24px'],
      },
    },
    root: {
      display: 'flex',
      gap: '135px',

      padding: '32px 155px',
      overflow: 'hidden',

      maxWidth: layout.maxWidth,
      margin: 'auto',

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        padding: '8px',
        gap: '32px',
        alignItems: 'center',
        justifyContent: 'stretch',
      },
    },
    text: {
      flex: 1,

      [mediaQuery(breakpoints.tablet)]: {
        padding: '32px',
      },
    },
    label: {
      fontSize: '20px !important',
      color: 'var(--x-text-color-2) !important',

      [mediaQuery(breakpoints.tablet)]: {
        textAlign: 'center',
      },
    },
    title: {
      fontSize: '60px !important',
      fontWeight: `${FontWeight.Regular} !important`,
      marginBottom: '24px',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '42px !important',
        lineHeight: '42px !important',
        textAlign: 'center',
      },
    },
    description: {
      fontSize: '16px !important',
      textAlign: 'justify',

      [mediaQuery(breakpoints.tablet)]: {
        textAlign: 'center',
      },
    },
    questions: {
      position: 'relative',
      flex: 1,

      display: 'flex',
      flexDirection: 'column',
      gap: spacing.xxLarge,
      alignItems: 'center',
    },
    hiddenQuestion: {
      display: 'none',
    },
    questionsOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,

      background: 'linear-gradient(180deg, transparent 0%, transparent 60%, var(--x-bg-1) 85%)',
    },
    question: {
      width: '100%',

      padding: '32px',
      borderRadius: '32px',

      background: 'var(--x-bg-2)',
    },
    questionTitle: {
      fontSize: '16px !important',
    },
    questionAnswer: {
      color: 'var(--x-text-color-2)',
      fontSize: '16px !important',
    },
  }),
  {
    name: 'faq-expanded-section',
  },
);

export default useStyles;
